import type { VoidFunctionComponent } from 'react';

import { window } from '../../../../globals';
import Button from '../../../generic/Button';
import Text from '../../../generic/Text';
import Tooltip from '../../../generic/Tooltip';

import { useContributors } from './hooks';

type Props = {
  isDisabled: boolean;
};

/**
 * Display a contributors section with a button to send a weekly contributor report
 */
const ContributorsSection: VoidFunctionComponent<Props> = ({ isDisabled }) => {
  const { isLoading, sendContributorsReport } = useContributors();

  return (
    <>
      <hr />
      <Text.H3>Contributors</Text.H3>
      <Tooltip id="weekly-contributors-report" tooltip="Download weekly contributor snapshot" showTooltip>
        <span className="inline-block  margin-left-xs">
          <Button size="medium" type="secondary" isDisabled={isLoading || isDisabled} onClick={sendContributorsReport}>
            Email Weekly Contributor Report to {window.user?.email}
          </Button>
        </span>
      </Tooltip>
    </>
  );
};

export default ContributorsSection;
